import { PaymentDetailsType } from 'scb-shared';

export const PropertyNames = {
  [PaymentDetailsType.CARD]: 'Картка',
  [PaymentDetailsType.PAYPAL]: 'PayPal',
  [PaymentDetailsType.MONOBANK_ACCUMULATION]: 'Моно банка',
  [PaymentDetailsType.IBAN]: 'IBAN',
  [PaymentDetailsType.CRYPTO]: 'Криптогаманець',
  [PaymentDetailsType.NONE]: 'Інше',
};

export const API_BASE_URL =
  'https://us-central1-share-card-prod.cloudfunctions.net' ||
  'http://localhost:5001/share-card-prod/us-central1' ||
  'https://e142-185-130-54-155.ngrok.io/share-card-prod/us-central1';
